import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionUtils } from '@shared/utils';
import { TabType, useTabs } from '@shared/hooks';
import { RewardsTab, StatementPaymentTab, StatementsCardTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const StatementsPage = () => {
  const tabsState = useTabs({ withRewardsTab: true });
  const { t } = useTranslation('statements');

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === TabType.Payment && PermissionUtils.viewStatementPaymentsTab()) return <StatementPaymentTab />;
    else if (tabsState.tab === TabType.Card && PermissionUtils.viewStatementCardsTab()) return <StatementsCardTab />;
    else if (tabsState.tab === TabType.Rewards) return <RewardsTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.tabs.length > 1 && (
        <Tabs className='mb-6' options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
      )}
      {currentTabView}
    </PageContainer>
  );
};
